import type { SubjectCode } from '~/models/Subject'
import type { GradeCode } from '~/models/Grade'
import type { ContentType } from '~/models/Content/ContentType'
import type { Assignment, AssignmentAnswer, AssignmentReportLine, AssignmentResponse } from '~/models/Assignment'
import { externalClient } from '~/api/client/externalClient'

export default function useAssignmentApi() {
  return {
    getAssignmentResponse: async (assignmentKey: string, groupIds: string[]): Promise<AssignmentResponse[]> =>
      (await externalClient.get(`/frontend/assignment/${assignmentKey}/response?groupIds=${groupIds}`)).data,

    getAssignment: async (assignmentKey: string): Promise<Assignment> =>
      (await externalClient.get(`/frontend/assignment/${assignmentKey}`)).data,

    getStudentAssignmentResponse: async (assignmentKey: string, studentUserId: string): Promise<AssignmentResponse> =>
      (await externalClient.get(`/frontend/assignment/${assignmentKey}/response/${studentUserId}`)).data,

    saveStudentAssignment: async (assignmentKey: string, studentUserId: string, answer: AssignmentAnswer): Promise<AssignmentAnswer> =>
      (await externalClient.put(`/frontend/assignment/${assignmentKey}/response/${studentUserId}/answer`, answer)).data,

    createStudentAssignment: async (assignmentKey: string, studentUserId: string, answer: AssignmentAnswer): Promise<AssignmentAnswer> =>
      (await externalClient.post(`/frontend/assignment/${assignmentKey}/response/${studentUserId}/answer`, answer)).data,

    getReport: async (
      groupId: string,
      lastActivityAfter: string,
      lastActivityBefore: string,
      contentType: ContentType,
      context: string,
      subject: SubjectCode,
      grade: GradeCode
    ): Promise<AssignmentReportLine[]> =>
      (await externalClient.get('/frontend/assignment/report', {
        params: {
          groupId,
          lastActivityAfter,
          lastActivityBefore,
          contentType,
          context,
          subject,
          grade,
        }
      })).data
  }
}
